module.exports = __webpack_public_path__ + "static/media/14. Te miro y me miro, Óleo y barniz en tela,100 x 100 cm, 2018 copy.b021ffc1.png";